import { Link } from "react-router-dom";
import Photo from "../components/ui/Photo";
import { STAFF, categoryLabel } from "../data/salon";
import { faRating, toFa } from "../lib/format";
import { useStagger } from "../lib/motion";
import PageHero from "../components/ui/PageHero";
import { useDocumentTitle } from "../lib/title";
import "./pages.css";

function Member({ person }) {
  return (
    <article
      className="mcard reveal"
      data-stagger=""
      style={{ "--tone": person.tone, "--tone2": person.tone2 }}
    >
      <div className="mcard__media">
        <Photo src={person.photo} alt={person.name} ratio="4 / 5" className="ph--hover" tint="soft" />
      </div>

      <div className="mcard__body">
        <span className="eyebrow">{person.latin}</span>
        <h3>{person.name}</h3>
        <p className="mcard__role">{person.role}</p>
        <p className="mcard__bio">{person.bio}</p>

        <dl className="mcard__stats">
          <div>
            <dt>{toFa(person.experience)}</dt>
            <dd>سال تجربه</dd>
          </div>
          <div>
            <dt>{faRating(person.rating)}</dt>
            <dd>امتیاز</dd>
          </div>
          <div>
            <dt>{toFa(person.reviews)}</dt>
            <dd>نظر</dd>
          </div>
        </dl>

        <div className="mcard__tags">
          {person.categories.map((c) => (
            <Link key={c} to={`/services?c=${c}`} className="mcard__tag">
              {categoryLabel(c)}
            </Link>
          ))}
        </div>
      </div>
    </article>
  );
}

export default function Staff() {
  useDocumentTitle("متخصصین");
  const grid = useStagger({ step: 80 });

  return (
    <>
      <PageHero
        eyebrow="OUR TEAM"
        title="متخصصین رُز"
        lede="هر کار را کسی انجام می‌دهد که همان یک حوزه را سال‌ها کار کرده است."
        tone="#CBB08A"
      />

      <section className="section">
        <div className="wrap wrap--wide">
          <div className="mgrid" ref={grid}>
            {STAFF.map((p) => <Member key={p.id} person={p} />)}
          </div>
        </div>
      </section>
    </>
  );
}
